export default {
  Ground: 'Ground',
  Expedited: 'Expedited',
  Overnight: 'Overnight'
}

export const ShipOptionsApiEnum = {
  Overnight: 1,
  Expedited: 2,
  Ground: 3
}

export const ShippingServiceCategory = {
  None: 1,
  ShipBobCustom: 2,
  ShipBobOptimized: 3,
  CarrierSpecific: 4,
  WRO: 5,
  Return: 6
}
